import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db, storage } from "../../firebaseConfig";
import Postpal_Logo from "../../assets/images/home.png";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import { getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { ref as sRef } from "firebase/database";

export const generatePdf = async (itemId) => {
  try {
    let data = {};
    const formDataRef = doc(db, "forms", itemId);
    const docSnap = await getDoc(formDataRef);
    if (docSnap.exists()) {
      data = docSnap.data()?.InspectionForm;
    }
    const document = new jsPDF();
    const pageWidth = document.internal.pageSize.getWidth(); // Get the page width

    // Add the logo image centered at the top
    const logoWidth = (48 * 25.4) / 96;
    const logoHeight = (48 * 25.4) / 96;
    const logoXPosition = (pageWidth - logoWidth) / 2;
    const logoYPosition = 20;

    document.addImage(
      Postpal_Logo,
      "PNG",
      logoXPosition,
      logoYPosition,
      logoWidth,
      logoHeight
    );

    // Set font size for the title
    document.setFontSize(18);

    // Center the title manually by calculating half the page width and offset for the string
    const title = "POSTPAL Inspection Report";
    document.text(title, pageWidth / 2, logoYPosition + logoHeight + 10, {
      align: "center",
    });

    // Set font size for the rest of the document
    document.setFontSize(12);

    const tbodyHeader = [
      [{ content: "Item Name" }, { content: data?.productname }],
      [{ content: "Package ID" }, { content: data?.ordernumber }],
      [{ content: "Item ID" }, { content: data?.productid }],
      [{ content: "Store Name" }, { content: data?.storename }],
    ];

    document.autoTable({
      startY: logoYPosition + logoHeight + 10 + 10,
      margin: 40,
      body: tbodyHeader,
      theme: "grid",
      styles: {
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        lineWidth: 0.3,
        fontStyle: "bold",
      },
      bodyStyles: {
        fontStyle: "bold",
      },
      columnStyles: {
        0: { cellWidth: 80 },
        1: { cellWidth: 50 },
      },
    });

    const tbody = [
      [
        {
          content:
            "In your view, is the package description the same as the item inside the box?",
        },
        {
          content: data?.inspectionConfirmation === false ? "No" : "Yes",
        },
      ],
      [{ content: "Serial number on box" }, { content: data?.serialnumberBox }],
      [
        { content: "Serial number from on the product" },
        {
          content: data?.serialnumberProduct,
        },
      ],
      [
        { content: "Serial number from on software information page" },
        {
          content: data?.serialnumberInformation,
        },
      ],
      [
        {
          content: "Any signs of damage to the outer box or packaging?",
        },
        {
          content: data?.packagingCheck === false ? "No" : "Yes",
        },
      ],
      [
        {
          content: "Any signs of damage to the item?",
        },
        {
          content: data?.packageDamage === false ? "No" : "Yes",
        },
      ],
      [
        {
          content: "Would you consider this New, Used, or Refrubrished?",
        },
        {
          content: data?.status === false ? "No" : "Yes",
        },
      ],
      [
        {
          content:
            "Does this come with charger or other AC able and power code?",
        },
        {
          content: `Charger: ${
            data?.powerCheck?.charger === false ? "No" : "Yes"
          }\nAC Cabel: ${
            data?.powerCheck?.acCable === false ? "No" : "Yes"
          }\nPower Code: ${
            data?.powerCheck?.powerCode === false ? "No" : "Yes"
          }\nDoes the electronic power on?: ${
            data?.powerCheck?.powerOn === false ? "No" : "Yes"
          }`,
        },
      ],
      [
        {
          content: "Does this item produce sounds",
        },
        {
          content: data?.soundCheck === false ? "No" : "Yes",
        },
      ],
      [
        {
          content: "Max Sound",
        },
        {
          content: data?.maxSound,
        },
      ],
      [
        {
          content: "Minimum Sound",
        },
        {
          content: data?.minSound,
        },
      ],
      [
        {
          content: "Any visible damage to the screen?",
        },
        {
          content: data?.screenCheck === false ? "No" : "Yes",
        },
      ],
      [
        {
          content:
            "Do you see any running lines across any part of the screen?",
        },
        {
          content: data?.screenRunning === false ? "No" : "Yes",
        },
      ],
      [
        {
          content: "Do you see any crack or peel on the screen?",
        },
        {
          content: data?.screenCrack === false ? "No" : "Yes",
        },
      ],
      [
        {
          content: "Are you able to see image on the screen?",
        },
        {
          content: data?.videoCheck === false ? "No" : "Yes",
        },
      ],
      [
        {
          content: "Is the image or video clearly visible?",
        },
        {
          content: data?.videoCheck === false ? "No" : "Yes",
        },
      ],
    ];

    document.autoTable({
      startY: document.previousAutoTable.finalY + 10,
      margin: 40,
      head: [["Question", "Details"]],
      body: tbody,
      theme: "grid",
      styles: {
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: ["#5E17EB"],
        textColor: ["#ffffff"],
        lineWidth: 0.3,
      },
      columnStyles: {
        0: { cellWidth: 80 },
        1: { cellWidth: 50 },
      },
      didParseCell: function (data) {
        if (data.section === "body" && data.column.index === 0) {
          // Set font style to bold for the first cell in each row
          data.cell.styles.fontStyle = "bold";
        }
        // if (data?.row?.index === 17) {
        //   // Adjust row height if it's the one with images
        //   data.row.height = 20;
        // }
      },
    });

    const tbodyFooter = [
      [
        { content: "comments and feedback" },
        {
          content: data?.commentFeedback,
        },
      ],
      [
        { content: "Report is prepared onbehalf of" },
        { content: data?.userName },
      ],
      [{ content: "Report is completed by" }, { content: "" }],
      [
        {
          content: "Inspection report number",
        },
        {
          content: data?.inspectionReport,
        },
      ],
    ];

    document.autoTable({
      startY: document.previousAutoTable.finalY + 10,
      margin: 40,
      body: tbodyFooter,
      theme: "grid",
      styles: {
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        lineWidth: 0.3,
      },
      columnStyles: {
        0: { cellWidth: 80 },
        1: { cellWidth: 50 },
      },
      didParseCell: function (data) {
        if (data.section === "body" && data.column.index === 0) {
          // Set font style to bold for the first cell in each row
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    const getImageType = (url) => {
      const extension = url.split(".").pop().split("?")[0];
      if (extension === "png") return "PNG";
      if (extension === "jpg" || extension === "jpeg") return "JPEG";
      if (extension === "gif") return "GIF";

      return "PNG";
    };

    const fetchImageAsBase64 = async (url) => {
      const response = await fetch(url);
      if (response.status === 200) {
        const blob = await response.blob();
        const reader = new FileReader();
        return new Promise((resolve, reject) => {
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
    };

    const prepareImages = async () => {
      const imageUrls = data?.inspectionUploadImg || [];

      const images = await Promise.all(
        imageUrls.map((url) => fetchImageAsBase64(url))
      );
      return images;
    };

    const base64Images = await prepareImages();

    // Add each image on a separate page
    base64Images.forEach((image, index) => {
      if (image) {
        document.addPage();
        const imageWidth = 50; // Fixed width for images
        const imageHeight = 50; // Fixed height for images
        const xPosition = (document.internal.pageSize.getWidth() - imageWidth) / 2;
        const yPosition = 20; // Margin from the top

        // Add title for the image page
        document.setFontSize(16);
        document.text("Uploaded Images", document.internal.pageSize.getWidth() / 2, 10, {
          align: "center",
        });

        document.addImage(
          image,
          getImageType(data?.inspectionUploadImg[index]),
          xPosition,
          yPosition,
          imageWidth,
          imageHeight
        );
      }
    });
    const blob = document.output("blob")
    // const storageRef = sRef(storage, `/forms/${itemId}_inspectionform`);
    // const uploadTask = uploadBytesResumable(storageRef, blob);
    // const logoUrl = await getDownloadURL(storageRef);
    // console.log(logoUrl,"logoURL");
    
    const url = URL.createObjectURL(blob);
    await updateDoc(formDataRef, {
        InspectionForm: {
        ...data,
        isDocGenerated: true,
        docUrl: url,
      },
    }).then(() => {
      toast.success("Document Generated Successfully");
    });
    // document.save("inspection-report.pdf");
  } catch (error) {
    console.error("Failed to generate PDF", error);
  }
};
